import { Link } from "react-router-dom";
import { Mail, Phone, ArrowRight } from "lucide-react";
import { PageMeta } from "@/components/Layout";
import { Reveal } from "@/components/Reveal";
import { PageHero, SectionHeader } from "@/components/Section";
import { SEO, PARTNERSHIPS, CONTACT } from "@/content/siteContent";

export default function Partnerships() {
    return (
        <>
            <PageMeta title={SEO.partnerships.title} description={SEO.partnerships.description} />
            <PageHero eyebrow="Partnerships" title={PARTNERSHIPS.title} intro={PARTNERSHIPS.intro}>
                <Reveal delay={0.15}>
                    <p
                        className="mt-8 inline-flex items-center gap-3 rounded-full border border-[#C8A15A]/40 px-5 py-2.5 text-[0.7rem] uppercase tracking-[0.24em] text-[#C8A15A]"
                        data-testid="partnership-status-badge"
                    >
                        <span className="glow-breathe inline-block h-1.5 w-1.5 rounded-full bg-[#C8A15A]" />
                        {PARTNERSHIPS.status}
                    </p>
                </Reveal>
            </PageHero>

            <section className="surface-ivory py-20 sm:py-28" data-testid="partnership-rooted">
                <div className="mx-auto max-w-4xl px-5 sm:px-8">
                    <SectionHeader eyebrow="Rooted in Chetla" title={PARTNERSHIPS.rooted.title} />
                    <Reveal delay={0.1}>
                        <div className="body-copy mt-8 max-w-2xl space-y-5">
                            {PARTNERSHIPS.rooted.body.map((p, i) => (
                                <p key={i}>{p}</p>
                            ))}
                        </div>
                    </Reveal>
                </div>
            </section>

            <section className="surface-dark py-20 sm:py-28" data-testid="partnership-enquire">
                <div className="mx-auto max-w-4xl px-5 text-center sm:px-8">
                    <Reveal>
                        <p className="eyebrow">Enquire</p>
                        <hr className="gold-rule gold-rule--center mx-auto mt-4" aria-hidden="true" />
                        <h2 className="font-display mt-5 text-3xl font-semibold text-[#FFF5E6] sm:text-4xl">
                            Start a preliminary conversation
                        </h2>
                        <p className="body-copy mx-auto mt-6 max-w-2xl text-[#FFF5E6]/70">
                            {PARTNERSHIPS.note}
                        </p>
                    </Reveal>
                    <Reveal delay={0.15} className="mt-10 flex flex-wrap items-center justify-center gap-4">
                        <a href={`mailto:${CONTACT.email}?subject=Partnership%20enquiry`} className="btn btn-gold" data-testid="partnership-email-cta">
                            <Mail size={15} /> {CONTACT.email}
                        </a>
                        <a href={CONTACT.phoneHref} className="btn btn-outline" data-testid="partnership-phone-cta">
                            <Phone size={15} /> {CONTACT.phoneDisplay}
                        </a>
                    </Reveal>
                    <Reveal delay={0.2} className="mt-8">
                        <Link
                            to="/contact"
                            className="inline-flex items-center gap-2 text-sm text-[#C8A15A] underline-offset-4 transition-colors hover:text-[#e2c07f] hover:underline"
                            data-testid="partnership-contact-link"
                        >
                            Or send an enquiry through the contact page <ArrowRight size={14} />
                        </Link>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
